import {
  BookOpenIcon,
  DocumentPlusIcon,
  ExclamationTriangleIcon,
  FolderIcon,
  PencilIcon,
} from "@heroicons/react/24/outline";
import { BoltIcon, ScaleIcon } from "@heroicons/react/24/solid";
import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCol,
  IonGrid,
  IonRow,
  IonText
} from "@ionic/react";
import "./PremiumFeatures.css";

const CARD_DATA: { Heroicon: typeof ScaleIcon; title: string; body: string }[] =
  [
    {
      Heroicon: ScaleIcon,
      body: "Ensure safe and balanced flights with our advanced weight and balance calculator.",
      title: "Weight and Balance",
    },
    {
      Heroicon: BoltIcon,
      body: "Maximize performance with comprehensive pre-flight planning.",
      title: "Performance Calculator",
    },
    {
      Heroicon: ExclamationTriangleIcon,
      body: "Review flight and driver risk assessments with MFRAT and DRAT.",
      title: "Risk Assessments",
    },
    {
      Heroicon: BookOpenIcon,
      body: "Access a wealth of training materials and quizzes to continuously improve your skills.",
      title: "Training",
    },
    {
      Heroicon: PencilIcon,
      body: "Access a wealth of training materials and quizzes to continuously improve your skills.",
      title: "Airplane Squawks Tracker",
    },
    {
      Heroicon: FolderIcon,
      body: "Store and organize all your important aircraft documents and information in one secure place.",
      title: "Document Storage",
    },
    {
      Heroicon: DocumentPlusIcon,
      body: "Generate comprehensive reports and gain valuable insights into your aircraft operations.",
      title: "Reports",
    },
  ] as const;
function CardMaker({ Heroicon, title, body }: (typeof CARD_DATA)[number]) {
  return (
    <IonCol sizeMd="4" sizeLg="3" sizeSm="5" sizeXs="12">
      <IonCard>
        <IonCardHeader>
          <IonRow>
            <IonCol size="2">
              <Heroicon className="hero small" />
            </IonCol>
            <IonCol size="10">
              <h2 className="ion-no-padding">{title}</h2>
            </IonCol>
          </IonRow>
        </IonCardHeader>
        <IonCardContent>
          <IonRow>
            <IonCol size="2"></IonCol>
            <IonCol size="10">
              <IonText>{body}</IonText>
            </IonCol>
          </IonRow>
        </IonCardContent>
      </IonCard>
    </IonCol>
  );
}
function PremiumFeatures({ id }: { id?: string }) {
  return (
    <IonRow className="premium-features white-cards" id={id}>
      <IonCol>
        <IonGrid>
          <IonRow>
            <IonText className="ion-no-padding title">
              Premium Features
            </IonText>
          </IonRow>
          <IonRow>
            {CARD_DATA.map((entry, index) => (
              <CardMaker key={index} {...entry}></CardMaker>
            ))}
          </IonRow>
        </IonGrid>
      </IonCol>
    </IonRow>
  );
}
export { PremiumFeatures };
